// src/i18n/index.ts
import { createI18n } from "vue-i18n";
import ko from "./ko.json";
import en from "./en.json";

import siteKo from "./site/ko.json";
import siteEn from "./site/en.json";

const getBrowserLocale = (): string => {
  const lang = navigator.language || navigator.languages[0] || "ko";
  return lang.toLowerCase().startsWith("en") ? "en" : "ko";
};

const initialLocale = sessionStorage.getItem("lang") || getBrowserLocale();
sessionStorage.setItem("lang", initialLocale);
document.documentElement.lang = initialLocale;

const i18n = createI18n({
  legacy: false,
  locale: initialLocale,
  fallbackLocale: "ko",
  messages: { ko: { ...ko, ...siteKo }, en: { ...en, ...siteEn } },
});

export default i18n;
